import React from "react";
import { Form, Input } from "antd";
import { FormattedMessage, useIntl } from "react-intl";

const { Item } = Form;

const InputItem = ({
  getFieldDecorator,
  allowClear = true,
  formItemLayout,
  variableSymbol,
  multipleEmails,
  onValueChange,
  autoComplete,
  initialValue,
  placeholder,
  wrapperCol,
  fieldName,
  maxLength,
  disabled,
  onChange,
  password,
  labelCol,
  optional,
  required,
  message,
  zipCode,
  pattern,
  account,
  suffix,
  unCode,
  label,
  email,
  url,
}) => {
  const intl = useIntl();
  return (
    <Item
      label={label}
      labelCol={labelCol ? { span: labelCol } : formItemLayout.labelCol}
      wrapperCol={wrapperCol ? { span: wrapperCol } : formItemLayout.wrapperCol}
    >
      {getFieldDecorator(fieldName, {
        ...{ initialValue },
        getValueFromEvent: onValueChange,
        rules: [
          {
            required: (required || message) && !optional,
            message: required ? (
              <FormattedMessage
                id="messages.input.required"
                defaultMessage="Tento údaj je povinný!"
              />
            ) : (
              message
            ),
          },
          email
            ? {
                type: "email",
                message: intl.formatMessage({
                  id: "messages.validEmail",
                  defaultMessage: "Zadejte prosím validní email!",
                }),
              }
            : {},
          multipleEmails
            ? {
                pattern:
                  "^(;?[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+)+$",
                message: intl.formatMessage({
                  id: "messages.validEmail",
                  defaultMessage: "Zadejte prosím validní email!",
                }),
              }
            : {},
          variableSymbol
            ? {
                pattern: "^\\d{0,10}$",
                message: intl.formatMessage({
                  id: "messages.validVariableSymbol",
                  defaultMessage:
                    "Variabilní symbol musí obsahovat pouze čísla a mít maximální délku 10!",
                }),
              }
            : unCode
            ? {
                pattern: "^\\d{4}$",
                message: intl.formatMessage({
                  id: "messages.validUnCode",
                  defaultMessage:
                    "UN kód musí obsahovat pouze čísla a být o délce 4!",
                }),
              }
            : zipCode
            ? {
                pattern: "^\\d{5}$",
                message: intl.formatMessage({
                  id: "address.validation.zipCode.five",
                  defaultMessage: "Zadejte PSČ v pětimístném formátu!",
                }),
              }
            : url
            ? {
                pattern:
                  /https:\/\/(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)/,
                message: intl.formatMessage({
                  id: "document.url.validation",
                  defaultMessage: "Zadejte platnou URL začínající na https.",
                }),
              }
            : account
            ? {
                pattern: "^z\\d{3,15}$",
                message: intl.formatMessage({
                  id: "messages.validAccount",
                  defaultMessage: "Zadejte validní zAccount!",
                }),
              }
            : pattern
            ? pattern
            : {},
        ],
      })(
        password ? (
          <Input.Password
            placeholder={placeholder}
            autoComplete={autoComplete || "off"}
          />
        ) : (
          <Input
            suffix={suffix}
            onChange={onChange}
            disabled={disabled}
            maxLength={maxLength}
            allowClear={allowClear}
            placeholder={placeholder}
            autoComplete={autoComplete || "off"}
            max={multipleEmails ? 128 : undefined}
          />
        )
      )}
    </Item>
  );
};

export default InputItem;
